export const navigations = [
	{
		name: 'Dashboard',
		path: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Task',
		icon: 'assignment',
		path: '/task',
	},
	{
		name: 'User',
		icon: 'account_box',
		path: '/user',
	},
	{
		name: 'My Leads',
		icon: 'gps_fixed',
		path: '/leads',
	},
	{
		name: 'City Head',
		icon: 'location_city',
		children: [
			{
				name: 'Pending Verification',
				path: '/cityhead/pending-leads',
				iconText: 'P',
			},
		],
	},
	{
		name: 'My Restaurants',
		icon: 'restaurant',
		children: [
			{
				name: 'Contact Info',
				path: '/restaurant/contact-info',
				iconText: 'C',
			},
			{
				name: 'Pending Payment',
				path: '/restaurant/pending-payment',
				iconText: 'P',
			},
			{
				name: 'Materialization',
				path: '/restaurant/materialization',
				iconText: 'M',
			},
		],
	},
	{
		name: 'Contacts',
		icon: 'contacts',
		path: '/contacts',
	},
	{
		name: 'My Team',
		icon: 'group',
		children: [
			{
				name: 'Team Leads',
				path: '/my-team/team-lead',
				iconText: 'T',
			},
			{
				name: 'Open Leads',
				path: '/my-team/assign-open-lead',
				iconText: 'O',
			},
		],
	},
	{
		name: 'Reports',
		icon: 'assessment',
		children: [
			{
				name: 'DSR',
				path: '/sales-report',
				iconText: 'D',
			},
			{
				name: 'Capture Delay',
				path: '/lead/delays',
				iconText: 'C',
			},
		],
	},
];
